import { create } from "zustand";

interface AuthState {
  isAuthExpired: boolean;
  setAuthExpired: (expired: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthExpired: false,
  setAuthExpired: (expired: boolean) => set({ isAuthExpired: expired }),
}));
